<template>
  <div class="g-my-animation-box">
    <el-tabs class="children_tabs" v-model="activeName" v-if="!isShowOnlyModule">
      <el-tab-pane :label="$t('components_my_animation_my_animation_2283')" name="1">
        <div class="edit_item" v-if="activeName === '1'">
          <div class="my_animation_module_type" v-if="isComb">
            <span>{{$t('components_my_animation_my_animation_2284')}}</span>
            <el-radio-group v-model="moduleType" @change="module_type_change">
              <el-radio label="module_animation">{{$t('components_my_animation_my_animation_2283')}}</el-radio>
              <el-radio label="comb_animation">{{$t('components_my_animation_my_animation_2285')}}</el-radio>
            </el-radio-group>
          </div>
          <my_module_animation v-if="moduleType === 'module_animation'" :defalutActive="moduleDefalutActive"
                               :defaultFormData="moduleDefalutFormData"
                               @change="my_module_change"></my_module_animation>
          <my_comb_animation v-if="moduleType === 'comb_animation'" :defalutActive="combDefalutActive"
                             :defaultFormData="combDefalutFormData" @change="my_comb_change"></my_comb_animation>
        </div>
        <div class="btn_wrap" v-if="showBtn">
          <div class="play_btn" @click="play('animation')">
            <label class="play_icon"></label>
            <span>{{$t('components_my_animation_my_animation_2286')}}</span>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('components_my_animation_my_animation_2287')" name="2" v-if="!isNotShowImage">
        <div class="edit_item" v-if="activeName === '2'">
          <my_image_animation :defalutActive="imageDefalutActive" :defaultFormData="imageDefalutFormData"
                              @change="my_image_change"></my_image_animation>
        </div>
        <div class="btn_wrap">
          <div class="play_btn" @click="play('effect')">
            <label class="play_icon"></label>
            <span>{{$t('components_my_animation_my_animation_2286')}}</span>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <template v-if="isShowOnlyModule && isComb">
      <div class="my_animation_module_type" v-if="isComb" style="margin-top: 30px;padding-left: 18px;">
        <span>{{$t('components_my_animation_my_animation_2284')}}</span>
        <el-radio-group v-model="moduleType" @change="module_type_change">
          <el-radio label="module_animation">{{$t('components_my_animation_my_animation_2283')}}</el-radio>
          <el-radio label="comb_animation">{{$t('components_my_animation_my_animation_2285')}}</el-radio>
        </el-radio-group>
      </div>

      <my_module_animation v-if="moduleType === 'module_animation'" :defalutActive="moduleDefalutActive"
                           :defaultFormData="moduleDefalutFormData" @change="my_module_change"
                           style="padding: 0px 18px;max-height: calc(100% - 130px);overflow: auto;"></my_module_animation>

      <my_comb_animation v-if="moduleType === 'comb_animation'" :defalutActive="combDefalutActive"
                         :defaultFormData="combDefalutFormData" @change="my_comb_change"
                         style="padding: 0 18px"></my_comb_animation>

    </template>
    <template v-else-if="isBanner">
      <my_banner_animation :defalutActive="moduleDefalutActive" :defaultFormData="moduleDefalutFormData"
                           @change="my_banner_change"
                           style="overflow: auto;"></my_banner_animation>
    </template>
    <template v-else>
      <my_module_animation v-if="isShowOnlyModule" :defalutActive="moduleDefalutActive"
                           :defaultFormData="moduleDefalutFormData" @change="my_module_change"
                           style="padding: 30px 18px;max-height: calc(100% - 64px);overflow: auto;"></my_module_animation>
    </template>


    <div class="btn_wrap" v-if="isShowOnlyModule && moduleDefalutActive !== 0 && !isBanner">
      <div class="play_btn" @click="play('animation')">
        <label class="play_icon"></label>
        <span>{{$t('components_my_animation_my_animation_2286')}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'my_animation',
  props: {
    isComb: {
      type: Boolean,
      default: false
    },
    isShowOnlyModule: {
      type: Boolean,
      default: false
    },
    isNotShowImage: {
      type: Boolean,
      default: false
    },
    isBanner: {
      type: Boolean,
      default: false
    },
    defaultModuleType: {
      type: String,
      default: 'module_animation'
    },
    combDefalutActive: {
      type: Number,
      default: 0
    },
    combDefalutFormData: {
      type: Object,
      default: () => {
      }
    },
    imageDefalutActive: {
      type: Number,
      default: 0
    },
    imageDefalutFormData: {
      type: Object,
      default: () => {
      }
    },
    moduleDefalutActive: {
      type: Number,
      default: 0
    },
    moduleDefalutFormData: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      activeName: '1',
      moduleType: this.defaultModuleType,
      animateType: '',
      animate: {},
      isFirst: true,
      recordModuleAnimateKey: '',
      recordModuleAnimateDirection: '',
      recordCombAnimateKey: '',
      recordCombAnimateDirection: ''
    }
  },
  computed: {
    showBtn() {
      if (this.defaultModuleType === 'module_animation') return this.moduleDefalutActive !== 0
      if (this.defaultModuleType === 'comb_animation') return this.combDefalutActive !== 0
    }
  },
  mounted() {
  },
  watch: {
    'recordAnimate.formData._key': {
      handler(val, oldVal) {
        this.getArticle(val.articleList, val.filterBy, val.type, this.isTypeState, this.pc_widgets_infor.page.pageStyle === 2)
      },
      deep: true
    },
    isNotShowImage(val) {
      if (val) {
        this.activeName = '1'
      }

    }

  },
  methods: {
    my_module_change(animate) {
      const isSame = animate.formData._key === this.recordModuleAnimateKey && animate.formData.direction === this.recordModuleAnimateDirection
      this.recordModuleAnimateKey = animate.formData._key
      this.recordModuleAnimateDirection = animate.formData.direction
      if (!this.isFirst) {
        this.$emit('change', 'module_animation', animate, !isSame)
      } else {
        this.isFirst = false
      }
    },
    my_image_change(animate) {
      this.animateType = 'image_animation'
      this.animate = animate
      this.$emit('change', 'image_animation', animate)
    },
    my_comb_change(animate) {
      // const isSame = animate.formData._key === this.recordCombAnimateKey && animate.formData.direction === this.recordCombAnimateDirection
      // this.recordCombAnimateKey = animate.formData._key
      // this.recordCombAnimateDirection = animate.formData.direction
      // this.recordAnimate = animate
      this.$emit('change', 'comb_animation', animate, true)
    },
    my_banner_change(animate) {
      this.$emit('change', 'banner_animation', animate, true)
    },
    module_type_change(moduleType) {
      this.$store.state.app.module_Data.data.animateType = moduleType
      this.$emit('module_type_change', moduleType)
    },
    play(type) {
      this.$emit('play', this.animateType, this.animate, type)
    }
  }
}
</script>

<style lang="scss" scoped>
.g-my-animation-box {
  display: flex;
  position: relative;
  flex-direction: column;
  height: 100%;

  .btn_wrap {
    position: absolute;
    bottom: 0;
    height: 64px;
    width: 380px;
    z-index: 9999;
    background: #fff;
  }

  .play_btn {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 130px;
    height: 34px;
    line-height: 34px;
    background: rgba(88, 116, 216, 1);
    border-radius: 17px;
    color: #fff;
    text-align: center;
    cursor: pointer;
  }

  .play_icon {
    background: url(/static/image/mbg01.png) -164px -600px no-repeat;
    width: 17px;
    height: 17px;
    margin-right: 7px;
  }
}

.children_tabs {
  .edit_item {
    overflow: auto;
    position: relative;
    height: 100%;
    max-height: calc(100% - 64px);
  }
}
</style>


<style lang="scss" scoped>
.my_animation_module_type {
  margin-bottom: 13px;
  padding: 0 6px;
  font-size: 14px;

  /deep/ .el-radio {
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_animation/my_animation.vue